
import { useGalleryPhotos } from "@/hooks/useGalleryPhotos";
import { GalleryHeader } from "./GalleryHeader";
import { GalleryTabs } from "./GalleryTabs";
import { PregnancyPhotoCollection } from "./PregnancyPhotoCollection";

interface UserGalleryProps {
  userId: string;
  isPremium: boolean;
}

export function UserGallery({ userId, isPremium }: UserGalleryProps) {
  const { 
    recentPhotos, 
    milestonePhotos, 
    collectionPhotos,
    refetch: fetchGalleryPhotos 
  } = useGalleryPhotos(userId);

  return (
    <div className="container max-w-5xl mx-auto px-4">
      <GalleryHeader isPremium={isPremium} />

      <GalleryTabs 
        userId={userId}
        isPremium={isPremium}
        recentPhotos={recentPhotos}
        milestonePhotos={milestonePhotos}
        collectionPhotos={collectionPhotos}
        fetchGalleryPhotos={fetchGalleryPhotos}
      />

      {/* Pregnancy Photos Collection */}
      <PregnancyPhotoCollection userId={userId} isPremium={isPremium} />
    </div>
  );
}
